module.exports = __webpack_public_path__ + "img/p64.00cbcaa0.jpg";